module.exports = __webpack_public_path__ + "static/Boydo-Tunnel-web-71116b00780ee9951316ac19d7fe621b.jpg";